import { Container, Texture, Sprite } from 'pixi.js';
import { Screen, ScreenPin, InteractionEvents } from "../../../node_modules/@cc/pixi-app";
import avatarConfig from "../../data/avatar-config.json";
import { ButtonBase } from './../common/ButtonBase';
import { avatarGenerator } from './../common/AvatarGenerator';
import { app } from './../app';
// import { Screen, ScreenPin, InteractionEvents } from "@cc/pixi-app";


export class ColorWheel {
    constructor(colors, creator){
        this.creator = creator;
        this.colorButtons = [];
        this.wheel = new Container();
        for (var i = 0; i < 6; i++){
            var back = new ButtonBase(new Texture.from("color-wheel"));
            back.anchor.set(0.5);
            var front = new Sprite.from("color-wheel");
            front.anchor.set(0.5);
            front.scale.set(0.9);
            back.addChild(front);
            this.colorButtons.push(back);
            this.wheel.addChild(back);
        }

        this.colorButtons[0].position.set(-410, 0);
        this.colorButtons[0].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(0);
        });
        this.colorButtons[1].position.set(-275, 140);
        this.colorButtons[1].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(1);
        });
        this.colorButtons[2].position.set(-100, 255);
        this.colorButtons[2].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(2);
        });
        this.colorButtons[3].position.set(100, 255);
        this.colorButtons[3].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(3);
        });
        this.colorButtons[4].position.set(275, 140);
        this.colorButtons[4].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(4);
        });
        this.colorButtons[5].position.set(410, 0);
        this.colorButtons[5].on(InteractionEvents.PointerTap, ()=> {
            app.sound.play("02-ui-click");
            this.setColor(5);
        });

        this.setupColorWheel(colors);
    }

    setupColorWheel(colors){
        if (colors === this.colors) return;
        this.colors = colors;
        var c = avatarConfig.colors[colors];
        for (var i = 0; i < 6; i++){
            let int = i;
            this.colorButtons[i].children[0].tint = c[i];
            this.animateIcon(this.colorButtons[i], int);
        }
    }

    animateIcon(icon, int){
        icon.scale.set(0);

        app.tween(icon.scale)
            .wait(int * 75)
            .to({x: 1, y: 1}, 200, createjs.Ease.elasticOut);
    }

    setColor(int){
        avatarConfig.colors.current[this.colors] = int;
        this.creator.onColorSelect();
        avatarGenerator.updateAnimations();
    }
}
